import { render, staticRenderFns } from "./User115AllCalls.vue?vue&type=template&id=4dc59db2&scoped=true&"
import script from "./User115AllCalls.vue?vue&type=script&lang=js&"
export * from "./User115AllCalls.vue?vue&type=script&lang=js&"
import style0 from "./User115AllCalls.vue?vue&type=style&index=0&id=4dc59db2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc59db2",
  null
  
)

export default component.exports